export default __webpack_public_path__ + "static/kat-302f08a5afa211e1ad7ddad0c9010ba4.jpg";